/* La colonne « UP-SPOT » de la liste des contacts (24/09/2026).
 *
 * C'était le besoin de départ : voir, dans les contacts, qui a un compte
 * UP-SPOT. La pastille dit le rôle du compte ; sa couleur dit s'il est actif,
 * désactivé, ou si l'invitation n'a pas encore été acceptée.
 *
 * L'état affiché est celui que la synchronisation a retenu, mis à jour en
 * temps réel. La fiche, elle, relit le compte en direct dans UP-SPOT.
 */

interface Props {
  compteId?: number | null
  role?: string | null
  statut?: 'actif' | 'desactive' | null
  invitationEnAttente?: number | boolean | null
}

export function UpSpotBadge({ compteId, role, statut, invitationEnAttente }: Props) {
  if (!compteId) return <span className="text-xs text-slate-400">—</span>

  const desactive = statut === 'desactive'
  const enAttente = !desactive && Boolean(Number(invitationEnAttente))

  const style = desactive
    ? 'bg-slate-100 text-slate-500 ring-slate-200'
    : enAttente
      ? 'bg-amber-50 text-amber-700 ring-amber-200'
      : 'bg-violet-50 text-violet-700 ring-violet-200'

  const libelle = desactive ? 'Désactivé' : (role || 'Compte')
  const bulle = desactive
    ? 'Compte UP-SPOT désactivé : la personne ne peut plus se connecter.'
    : enAttente
      ? `Compte UP-SPOT (${role ?? 'rôle inconnu'}) : l'invitation n'a pas encore été acceptée.`
      : `Compte UP-SPOT actif, rôle ${role ?? 'inconnu'}.`

  return (
    <span
      title={bulle}
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold ring-1 whitespace-nowrap ${style}`}
    >
      {libelle}
      {enAttente && <span className="ml-1 font-normal">· en attente</span>}
    </span>
  )
}
